module.exports = __webpack_public_path__ + "img/hero-4-mobile.233f97e3.jpg";